import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SectionInitialState } from './types';
import { createSection, deleteSectionById, fetchSections, updateSectionById } from './thunks';

const initialState: SectionInitialState = {
  isOpenSaveSection: false,
  sectionList: [],
  createSectionLoading: false,
  readSectionLoading: false,
  updateSectionLoading: false,
  deleteSectionLoading: false,
  defaultActiveCategoryId: null,
};

const sectionSlice = createSlice({
  name: 'section',
  initialState,
  reducers: {
    setIsOpenSaveSection(state, action: PayloadAction<boolean>) {
      state.isOpenSaveSection = action.payload;
    },
    setDefaultActiveCategoryId(state, action: PayloadAction<string | null>) {
      state.defaultActiveCategoryId = action.payload;
    },
  },
  extraReducers: (builder) => {
    // --- Create Section ---
    builder
      .addCase(createSection.pending, (state) => {
        state.createSectionLoading = true;
      })
      .addCase(createSection.fulfilled, (state, action) => {
        state.createSectionLoading = false;
        state.sectionList = [action.payload, ...state.sectionList];
      })
      .addCase(createSection.rejected, (state) => {
        state.createSectionLoading = false;
      });

    // --- Fetch Section ---
    builder
      .addCase(fetchSections.pending, (state) => {
        state.readSectionLoading = true;
      })
      .addCase(fetchSections.fulfilled, (state, action) => {
        state.readSectionLoading = false;
        state.sectionList = action.payload;
      })
      .addCase(fetchSections.rejected, (state) => {
        state.readSectionLoading = false;
      });

    // --- Update Section ---
    builder
      .addCase(updateSectionById.pending, (state) => {
        state.updateSectionLoading = true;
      })
      .addCase(updateSectionById.fulfilled, (state, action) => {
        state.updateSectionLoading = false;
        const index = state.sectionList.findIndex((section) => section.id === action.payload.id);

        if (index !== -1) {
          state.sectionList[index] = action.payload;
        }
      })
      .addCase(updateSectionById.rejected, (state) => {
        state.updateSectionLoading = false;
      });
    // --- Delete Section ---
    builder
      .addCase(deleteSectionById.pending, (state) => {
        state.deleteSectionLoading = true;
      })
      .addCase(deleteSectionById.fulfilled, (state, action) => {
        state.deleteSectionLoading = false;
        const index = state.sectionList.findIndex((section) => section.id === action.payload.id);
        if (index !== -1) {
          state.sectionList.splice(index, 1);
        }
      })
      .addCase(deleteSectionById.rejected, (state) => {
        state.deleteSectionLoading = false;
      });
  },
});
export const { setIsOpenSaveSection, setDefaultActiveCategoryId } = sectionSlice.actions;
export default sectionSlice.reducer;
